import React, { useState } from "react";
import { Lightbulb, Send, X } from "lucide-react";
import api, { apiError } from "@/lib/api";

export default function SuggestCategory({ compact = false }) {
  const [open, setOpen] = useState(false);
  const [message, setMessage] = useState("");
  const [email, setEmail] = useState("");
  const [busy, setBusy] = useState(false);
  const [done, setDone] = useState(false);
  const [error, setError] = useState("");

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    setError("");
    try {
      await api.post("/listings/suggest-category", {
        message,
        contact_email: email || null,
      });
      setDone(true);
    } catch (err) {
      setError(apiError(err));
    } finally {
      setBusy(false);
    }
  };

  const close = () => {
    setOpen(false);
    // Reset after a tick so animation works
    setTimeout(() => {
      setDone(false);
      setMessage("");
      setEmail("");
      setError("");
    }, 200);
  };

  return (
    <>
      <div
        className={`stb-card p-3 ${compact ? "mt-3" : "mt-4"}`}
        data-testid="suggest-category-block"
      >
        <p className="text-xs text-[#A3A3A3] leading-snug">
          <Lightbulb size={12} className="inline text-[#FF6B00] mr-1" />
          Chybí zde nějaká kategorie?
        </p>
        <button
          type="button"
          onClick={() => setOpen(true)}
          className="stb-btn stb-btn-outline w-full justify-center mt-2 text-xs"
          data-testid="suggest-category-open"
        >
          Navrhnout
        </button>
      </div>

      {open && (
        <div
          className="fixed inset-0 z-50 flex items-end sm:items-center justify-center bg-black/70 p-3"
          onClick={close}
          data-testid="suggest-category-modal"
        >
          <div
            className="stb-card max-w-md w-full p-5 relative"
            onClick={(e) => e.stopPropagation()}
          >
            <button
              type="button"
              onClick={close}
              className="absolute top-3 right-3 text-[#A3A3A3] hover:text-[#FF6B00]"
              aria-label="Zavřít"
              data-testid="suggest-category-close"
            >
              <X size={18} />
            </button>

            {done ? (
              <>
                <h2 className="stb-h text-2xl text-[#22C55E]">Děkujeme 🙌</h2>
                <p className="text-sm text-[#A3A3A3] mt-2">
                  Návrh jsme dostali. Mrkneme se na něj a pokud dává smysl,
                  rozšíříme katalog. Nejsme namyšlená firma — komunita rozhoduje.
                </p>
                <button
                  onClick={close}
                  className="stb-btn stb-btn-primary w-full mt-4"
                  data-testid="suggest-category-done"
                >
                  Hotovo
                </button>
              </>
            ) : (
              <>
                <h2 className="stb-h text-2xl text-white inline-flex items-center gap-2">
                  <Lightbulb size={20} className="text-[#FF6B00]" /> Navrhnout kategorii
                </h2>
                <p className="text-sm text-[#A3A3A3] mt-2">
                  Nenašel/a jsi vhodnou kategorii? Napiš nám, jakou bys uvítal/a.
                  Doplníme ji.
                </p>
                <form onSubmit={submit} className="mt-4 space-y-3">
                  <textarea
                    className="stb-input"
                    placeholder={'Např. „Sleva – pomůcky pro elektrikáře" nebo název kategorie + krátký popis.'}
                    value={message}
                    onChange={(e) => setMessage(e.target.value)}
                    required
                    minLength={2}
                    maxLength={2000}
                    data-testid="suggest-category-message"
                  />
                  <input
                    className="stb-input"
                    type="email"
                    placeholder="Tvůj e-mail (volitelné, pokud chceš odpověď)"
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                    data-testid="suggest-category-email"
                  />
                  {error && (
                    <p className="text-[#FF6B00] text-sm" data-testid="suggest-category-error">
                      {error}
                    </p>
                  )}
                  <button
                    type="submit"
                    className="stb-btn stb-btn-primary w-full"
                    disabled={busy}
                    data-testid="suggest-category-submit"
                  >
                    <Send size={14} /> {busy ? "Odesílám…" : "Odeslat návrh"}
                  </button>
                </form>
              </>
            )}
          </div>
        </div>
      )}
    </>
  );
}
